import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deletePpiTableRow } from '../actions';
import PPITableRow from './PPITableRow';
import { Table, TableHeader, TableBody, TableHeaderColumn, TableRow } from 'material-ui/Table';
import { grey50 } from 'material-ui/styles/colors';

const tableHeaderStyle = {
    backgroundColor: grey50,
    textTransform: 'capitalize'
};

const tableRowColumnTitleStyle = {
    width: 220
};

const tableRowColumnDeleteStyle = {
    width: 62
};

function PPITable({ typePlayersList, tableRowList, deletePpiTableRow }) {
    return (
        <Table selectable={false} hoverable={false}>
            <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
                enableSelectAll={false}
                style={tableHeaderStyle}
            >
                <TableRow>
                    <TableHeaderColumn key="title" style={tableRowColumnTitleStyle}>
                        Title
                    </TableHeaderColumn>
                    {typePlayersList.map(typePlayer => (
                        <TableHeaderColumn key={typePlayer}>{typePlayer}</TableHeaderColumn>
                    ))}
                    <TableHeaderColumn key="delete" style={tableRowColumnDeleteStyle} />
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} showRowHover={false} deselectOnClickaway={false}>
                {tableRowList.map(labelId => (
                    <PPITableRow
                        key={labelId}
                        labelId={labelId}
                        typePlayersList={typePlayersList}
                        deletePpiTableRow={deletePpiTableRow}
                    />
                ))}
            </TableBody>
        </Table>
    );
}

PPITable.propTypes = {
    // From connect
    typePlayersList: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    tableRowList: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    deletePpiTableRow: PropTypes.func.isRequired
};

export default connect(
    ({ ppi: { tableRowVisibleList, typePlayersList } }) => ({
        typePlayersList,
        tableRowList: tableRowVisibleList
    }),
    { deletePpiTableRow }
)(PPITable);



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/components/PPITable.js
 **/